export default __webpack_public_path__ + "static/logo-4830b583e526b688414b3d6f7bc75112.svg";